var _polygon, _path, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Error1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-95",
    d: "M76.34,230.4c-95.91,55.37-95.91,145.15,0,200.52s251.42,55.38,347.32,0,95.91-145.15,0-200.52S172.24,175,76.34,230.4Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.14,230.37c-.5.49-1.3,1.17-2.32,2-6.39,5.44-21.28,18.09-23.16,35.73l-2.06-.53c-.18-19.33,13.45-39.14,22.83-43.15a.43.43,0,0,0,.23-.57.44.44,0,0,0-.57-.23c-9.46,4-23.46,23.44-23.36,43.73l-1.39-.36c-.52-1.76-3.58-14,4.93-30.15a57.11,57.11,0,0,1,4.9-7.71l.09-.1c5.92-7.71,12.93-12.11,17.74-10.54a6.47,6.47,0,0,1,4.61,4.64A7.73,7.73,0,0,1,448.14,230.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.19,212.29c-3.85,5.52-7.84,11.23-9.69,16.34a54.62,54.62,0,0,0-5,7.85,52.62,52.62,0,0,0-5.14,14.22c-.78-29.37,15.33-52.4,20.25-56.51a.43.43,0,0,0,.05-.61.44.44,0,0,0-.61-.06c-5.24,4.36-22.91,29.74-20.34,61.43a.07.07,0,0,0,0,.05,34.62,34.62,0,0,0,.64,11.74l-2.43-.74c-.65-2.2-5.71-20.83-1.55-45.51,2.21-13.19,9.85-26,18.17-30.54,3.85-2.08,7.62-2.35,11.21-.79a5.68,5.68,0,0,1,3.56,3.59C447.62,197.34,442.55,204.6,437.19,212.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.46,223a7.42,7.42,0,0,0-5.19-5.28c-4.62-1.51-11.07,2-16.83,8.56-.65.75-1.3,1.54-1.94,2.37a54.62,54.62,0,0,0-5,7.85,52.62,52.62,0,0,0-5.14,14.22c-.3,1.51-.5,3-.64,4.3a34.62,34.62,0,0,0,.64,11.74c.12.5.21.78.22.8a.43.43,0,0,0,.21.23l.08,0h0l2.1.54,2.94.75a.33.33,0,0,0,.17,0,.49.49,0,0,0,.19-.07.44.44,0,0,0,.18-.31c1.61-17.55,16.54-30.24,22.92-35.66,1-.87,1.84-1.56,2.36-2.08A8.6,8.6,0,0,0,451.46,223Zm-3.32,7.39c-.5.49-1.3,1.17-2.32,2-6.39,5.44-21.28,18.09-23.16,35.73l-2.06-.53-.87-.22-1.39-.36c-.52-1.76-3.58-14,4.93-30.15a57.11,57.11,0,0,1,4.9-7.71l.09-.1c5.92-7.71,12.93-12.11,17.74-10.54a6.47,6.47,0,0,1,4.61,4.64A7.73,7.73,0,0,1,448.14,230.37Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.43,224.46c-9.38,4-23,23.82-22.83,43.15V268a.42.42,0,0,1-.36.43h-.07l-.18,0a.45.45,0,0,1-.25-.39c0-.19,0-.38,0-.57-.1-20.29,13.9-39.71,23.36-43.73a.44.44,0,0,1,.57.23A.43.43,0,0,1,443.43,224.46Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,212.79a105.76,105.76,0,0,0-8.46,13.47c-.44.94-.83,1.85-1.15,2.75,0,0-.4.32-.56.26a.44.44,0,0,1-.26-.56l0-.08c1.85-5.11,5.84-10.82,9.69-16.34,5.36-7.69,10.43-14.95,9.13-19.54a5.68,5.68,0,0,0-3.56-3.59c-3.59-1.56-7.36-1.29-11.21.79-8.32,4.51-16,17.35-18.17,30.54-4.16,24.68.9,43.31,1.55,45.51l2.43.74.76.23a.44.44,0,0,1,.29.55.45.45,0,0,1-.35.3.41.41,0,0,1-.19,0l-.08,0-3.34-1a.44.44,0,0,1-.29-.29c-.06-.19-6.09-19.78-1.65-46.14,2.27-13.43,10.09-26.54,18.62-31.16,4.1-2.22,8.13-2.5,12-.82a6.54,6.54,0,0,1,4,4.14C448.56,197.5,443.39,204.93,437.9,212.79Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.61,194.19c-4.92,4.11-21,27.14-20.25,56.51,0,1.38.11,2.78.22,4.18a.43.43,0,0,1-.36.47h0a.44.44,0,0,1-.46-.36.07.07,0,0,1,0-.05c-2.57-31.69,15.1-57.07,20.34-61.43a.44.44,0,0,1,.61.06A.43.43,0,0,1,437.61,194.19Z",
    style: {
      fill: "#09B842"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.34,86.15,268,91.54c0-.42.08-.83.08-1.24V87.6c0-4.81-3.38-6.76-7.55-4.35a14.59,14.59,0,0,0-4.49,4.32c-.68-6-5.43-8.3-11.19-5-6.23,3.59-11.28,12.34-11.28,19.54v4a10.72,10.72,0,0,0,.95,4.69l-7.74,4.47a9.22,9.22,0,0,0-4.19,7.24c0,2.67,1.87,3.75,4.19,2.42l50.55-29.19a9.22,9.22,0,0,0,4.18-7.24C281.52,85.9,279.65,84.82,277.34,86.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.47,92l-7,4.06c0-.31.06-.62.06-.93v-2c0-3.63-2.55-5.1-5.69-3.28a10.94,10.94,0,0,0-3.4,3.26c-.51-4.57-4.09-6.27-8.44-3.75-4.7,2.71-8.52,9.31-8.52,14.74v3a7.9,7.9,0,0,0,.73,3.54L296.32,114a6.94,6.94,0,0,0-3.16,5.46c0,2,1.41,2.83,3.16,1.83l38.15-22a7,7,0,0,0,3.16-5.47C337.63,91.79,336.21,91,334.47,92Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278,399.25l-7.48-4.32,5.44-3.14a5.78,5.78,0,0,0,0-10.4l-13.54-7.82a11.4,11.4,0,0,0-10.61,0l-9.14,5.28-47.22-27.27a10.62,10.62,0,0,0-5.3-1.31,10.5,10.5,0,0,0-5.31,1.31l-19.3,11.15a9.57,9.57,0,0,0-3.46,3,6.88,6.88,0,0,0-.74,5l10,50c.58,2.51,2.46,4.7,5.59,6.51L190.44,435a10.4,10.4,0,0,0,5.29,1.31h0A10.41,10.41,0,0,0,201,435l38.41-22.17,11.18,6.45a11.44,11.44,0,0,0,10.61,0L278,409.65a5.77,5.77,0,0,0,0-10.4Zm-74.38,2.14-2.24-11.26,10.87,6.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-95",
    d: "M63.29,395.35A101,101,0,0,1,85.2,406.53C92.86,411.71,99.87,418,108,422.27c10.62,5.59,22.84,7.61,34.8,7,6.77-.33,14.14-1.81,18.5-7.15a8.09,8.09,0,0,0,2-4.81c0-2.6-1.73-4.84-3.57-6.64C150,401.13,136.25,397.19,123,394.1s-21.18-6.93-34.17-13.87c-5.56-3-11-6.17-16.64-9l-.14-.07a87.46,87.46,0,0,0-8.51-4.08c-3.83-1.41-7-2.44-11.24-2.12s-9,.25-11.92,3.68a9.83,9.83,0,0,0-1.32,10.54C43.18,388.68,54.43,392.12,63.29,395.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,321.45c-3.39-2.15-7.13-4.41-11.13-6.72s-8-4.49-11.91-6.57a85.79,85.79,0,0,0-16.56-6.41,74.13,74.13,0,0,0-18.77-2.6H294a81.17,81.17,0,0,0-19,2.36,77.2,77.2,0,0,0-20.28,8.29c-6.89,4-11.74,8-14.81,12.17-3.21,4.41-4.76,8.87-4.61,13.27a20.66,20.66,0,0,0,5.13,12.52,49.77,49.77,0,0,0,11.48,9.92c3.5,2.22,7.33,4.53,11.38,6.87s8,4.5,11.65,6.43a86.38,86.38,0,0,0,16.57,6.4,73.55,73.55,0,0,0,18.76,2.6h.88a80.89,80.89,0,0,0,19-2.36,77.06,77.06,0,0,0,20.28-8.29c6.9-4,11.75-8,14.81-12.17,3.22-4.4,4.77-8.87,4.61-13.27a20.63,20.63,0,0,0-5.13-12.52A50.13,50.13,0,0,0,353.19,321.45Zm-23,26.48c-.35.53-1.32,1.64-4,3.18a22.86,22.86,0,0,1-6.48,2.62,23.44,23.44,0,0,1-4.94.55c-.44,0-.88,0-1.32,0a23.29,23.29,0,0,1-6-1.18,42.08,42.08,0,0,1-6.2-2.7,234.83,234.83,0,0,1-21.2-12.25,22.35,22.35,0,0,1-4.28-3.33,5.08,5.08,0,0,1-1.41-2.25c0-.12-.11-.51.43-1.34.35-.52,1.32-1.63,4-3.18a22.53,22.53,0,0,1,6.48-2.61,22.17,22.17,0,0,1,4.72-.53c.49,0,1,0,1.43.05a24.16,24.16,0,0,1,6,1.22,51.84,51.84,0,0,1,6.31,2.61C311,332.57,318.15,336.69,325,341a26.32,26.32,0,0,1,4.41,3.37,4.29,4.29,0,0,1,1.33,2.07C330.72,346.59,330.8,347,330.21,347.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.66,291.47l-7.48-4.32,5.44-3.14a5.78,5.78,0,0,0,0-10.4l-13.55-7.82a11.4,11.4,0,0,0-10.61,0l-9.14,5.27L382.1,243.8a11.4,11.4,0,0,0-10.61,0L352.2,254.94a9.53,9.53,0,0,0-3.47,3,6.86,6.86,0,0,0-.74,5l10,50c.58,2.51,2.46,4.7,5.59,6.51l13.55,7.82a10.4,10.4,0,0,0,5.29,1.31h0a10.41,10.41,0,0,0,5.3-1.31l38.41-22.18,11.18,6.46a11.4,11.4,0,0,0,10.61,0l16.73-9.66a5.77,5.77,0,0,0,0-10.4Zm-74.38,2.13L388,282.35l10.87,6.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.49,398a2,2,0,0,1,1.69,0l3.31,1.92a.54.54,0,0,1,.34.48.57.57,0,0,1-.34.49l-14.8,8.55a1.89,1.89,0,0,1-1.69,0l-20.18-11.65a.6.6,0,0,1-.35-.49.61.61,0,0,1,.35-.49l14.56-8.4a1.86,1.86,0,0,1,1.68,0l3.31,1.91a.58.58,0,0,1,.35.49.59.59,0,0,1-.35.49l-9.62,5.55,3.38,1.95,8.93-5.16a1.89,1.89,0,0,1,1.69,0l3.31,1.91a.57.57,0,0,1,.34.49.58.58,0,0,1-.34.49l-8.94,5.15,3.5,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.43,382.2a1.89,1.89,0,0,1,1.69,0l3.15,1.82a.57.57,0,0,1,.34.49.58.58,0,0,1-.34.49l-2.84,1.64c-1.92,1.1-1.92,2.21,0,3.31l7.68,4.44a.58.58,0,0,1,.35.49.59.59,0,0,1-.35.49l-3.93,2.27a1.89,1.89,0,0,1-1.69,0l-14.56-8.41a.52.52,0,0,1,0-1l3.63-2.09a1.86,1.86,0,0,1,1.68,0l.72.41a3.17,3.17,0,0,1,.61-1.65,6.12,6.12,0,0,1,2-1.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.55,373.47a1.68,1.68,0,0,1,.84-.2,1.72,1.72,0,0,1,.85.2l3.15,1.82a.57.57,0,0,1,.34.49.58.58,0,0,1-.34.49l-2.84,1.64q-2.88,1.65,0,3.32l7.68,4.43a.55.55,0,0,1,.34.49.58.58,0,0,1-.34.49l-3.93,2.27a1.89,1.89,0,0,1-1.69,0l-14.56-8.41a.56.56,0,0,1-.34-.48.57.57,0,0,1,.34-.49l3.63-2.09a1.66,1.66,0,0,1,.84-.2,1.68,1.68,0,0,1,.84.2l.72.41a3.17,3.17,0,0,1,.61-1.65,6.12,6.12,0,0,1,2-1.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,366c.34.17.75.39,1.24.67s.87.52,1.17.72a6.46,6.46,0,0,1,2.12,2,3.69,3.69,0,0,1,.58,2.31,4.55,4.55,0,0,1-1.09,2.42,10.49,10.49,0,0,1-2.89,2.32,16.83,16.83,0,0,1-4,1.67,18.48,18.48,0,0,1-4.18.63,17.15,17.15,0,0,1-4-.34,13,13,0,0,1-3.5-1.22c-.33-.17-.74-.4-1.23-.68s-.88-.52-1.17-.71a6.29,6.29,0,0,1-2.16-2,3.71,3.71,0,0,1-.56-2.33,4.68,4.68,0,0,1,1.1-2.43,9.77,9.77,0,0,1,2.87-2.33,16.31,16.31,0,0,1,4-1.66,19.41,19.41,0,0,1,4.22-.63,16.51,16.51,0,0,1,4,.33A12.92,12.92,0,0,1,403.41,366Zm-9.12,7.86a5.68,5.68,0,0,0,2.72.58,5.82,5.82,0,0,0,2.69-.78c.83-.48,1.28-1,1.34-1.55s-.27-1.07-1-1.57a10.32,10.32,0,0,0-1-.65,12,12,0,0,0-1.13-.57,5.5,5.5,0,0,0-2.71-.58,5.77,5.77,0,0,0-2.69.77c-.83.49-1.28,1-1.34,1.56s.27,1.07,1,1.57a8.79,8.79,0,0,0,1,.64A10.06,10.06,0,0,0,394.29,373.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,353.27a1.89,1.89,0,0,1,1.69,0l3.16,1.82a.58.58,0,0,1,.34.49.57.57,0,0,1-.34.49l-2.85,1.64q-2.86,1.65,0,3.32l7.69,4.43a.58.58,0,0,1,.34.49.57.57,0,0,1-.34.49l-3.94,2.27a1.68,1.68,0,0,1-.84.2,1.66,1.66,0,0,1-.84-.2L401,360.31a.59.59,0,0,1-.35-.49.58.58,0,0,1,.35-.49l3.62-2.09a1.89,1.89,0,0,1,1.69,0l.72.41a3.09,3.09,0,0,1,.61-1.65,6,6,0,0,1,2-1.65Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--404--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.64,389.58l-16.74,9.66a7.65,7.65,0,0,1-6.89,0l-13-7.52L197.71,415a7.77,7.77,0,0,1-6.91,0l-13.54-7.83q-3.33-1.9-3.84-4.13l-10-49.88a4.75,4.75,0,0,1-.07-.89c0,1,0,13.41,0,14a5.5,5.5,0,0,0,.07.77l10,49.88q.51,2.22,3.84,4.13l13.54,7.82a7.69,7.69,0,0,0,6.91,0L238,405.62l13,7.52a7.65,7.65,0,0,0,6.89,0l16.74-9.66a2.34,2.34,0,0,0,1.41-2v-13.9A2.35,2.35,0,0,1,274.64,389.58Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,383.63v-13.9a2.38,2.38,0,0,1-1.41,2l-11,6.34,11.87,6.85A2,2,0,0,0,274,383.63Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.78 381.67 206.11 386.5 218.16 379.55 194.64 365.96 197.77 381.67 197.78 381.67",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.78 381.67 206.11 386.5 218.16 379.55 194.64 365.96 197.77 381.67 197.78 381.67",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,383.63v-13.9a2.38,2.38,0,0,1-1.41,2l-11,6.34,11.87,6.85A2,2,0,0,0,274,383.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,389.58l-16.74,9.66a6.7,6.7,0,0,1-3.45.82V414a6.7,6.7,0,0,0,3.45-.82l16.74-9.66a2.34,2.34,0,0,0,1.41-2v-13.9A2.35,2.35,0,0,1,274.64,389.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,403l-10-49.88a4.75,4.75,0,0,1-.07-.89c0,1,0,13.41,0,14a5.5,5.5,0,0,0,.07.77l10,49.88a3.57,3.57,0,0,0,.31.84v-13.9A3.57,3.57,0,0,1,173.42,403Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,415.78a7,7,0,0,1-3.46-.81l-13.54-7.83a8.18,8.18,0,0,1-3.53-3.29v13.9a8.18,8.18,0,0,0,3.53,3.29l13.54,7.82a6.87,6.87,0,0,0,3.46.82,1.63,1.63,0,0,0,.38,0v-13.9A1.63,1.63,0,0,1,194.26,415.78Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,415a6.48,6.48,0,0,1-3.07.78v13.9a6.37,6.37,0,0,0,3.07-.79L238,405.62v-13.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,399.24l-13-7.52v13.9l13,7.52a6.64,6.64,0,0,0,3.44.82v-13.9A6.64,6.64,0,0,1,251,399.24Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,399.24a7.67,7.67,0,0,1-6.9,0l-13-7.52L197.71,415a7.75,7.75,0,0,1-6.9,0l-13.55-7.82q-3.31-1.92-3.83-4.13l-10-49.88a3.24,3.24,0,0,1,.25-2.29,6.43,6.43,0,0,1,2.18-1.77l19.29-11.14a6.84,6.84,0,0,1,3.46-.81,6.76,6.76,0,0,1,3.44.81l49.08,28.33,11-6.34a7.67,7.67,0,0,1,6.9,0l13.55,7.82a2.11,2.11,0,0,1,0,4l-11,6.35,13,7.52a2.12,2.12,0,0,1,0,4Zm-39.75-19.7L194.64,366l4.86,24.35Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.62,327.87c-.06,3.35-1.38,6.77-3.92,10.25q-4.08,5.61-13.67,11.14a73.29,73.29,0,0,1-19.3,7.9,76.17,76.17,0,0,1-19,2.25,69.93,69.93,0,0,1-17.82-2.47,81.64,81.64,0,0,1-15.86-6.13c-3.66-1.92-7.48-4-11.5-6.35s-7.75-4.56-11.24-6.78a45.68,45.68,0,0,1-10.6-9.15,16.84,16.84,0,0,1-4.28-10.29c.07,2.2-.09,11.46,0,13.9a16.84,16.84,0,0,0,4.28,10.29,45.68,45.68,0,0,0,10.6,9.15q5.23,3.33,11.24,6.78c4,2.31,7.84,4.43,11.5,6.36a82.27,82.27,0,0,0,15.86,6.12,69.93,69.93,0,0,0,17.82,2.47,76.17,76.17,0,0,0,19-2.25,73.29,73.29,0,0,0,19.3-7.9q9.6-5.54,13.67-11.14c2.73-3.73,4-7.39,3.9-10.95C364.53,339,364.66,331,364.62,327.87Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,359.34c-1.14,0-2.28.09-3.41.07a69.93,69.93,0,0,1-17.82-2.47,81.64,81.64,0,0,1-15.86-6.13c-3.66-1.92-7.48-4-11.5-6.35s-7.75-4.56-11.24-6.78a45.68,45.68,0,0,1-10.6-9.15,16.84,16.84,0,0,1-4.28-10.29c.07,2.2-.09,11.46,0,13.9a16.84,16.84,0,0,0,4.28,10.29,45.68,45.68,0,0,0,10.6,9.15q5.23,3.33,11.24,6.78c4,2.31,7.84,4.43,11.5,6.36a82.27,82.27,0,0,0,15.86,6.12,69.93,69.93,0,0,0,17.82,2.47c1.13,0,2.27,0,3.41-.07Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.62,327.87c-.06,3.35-1.38,6.77-3.92,10.25q-4.08,5.61-13.67,11.14a73.29,73.29,0,0,1-19.3,7.9,77.69,77.69,0,0,1-15.56,2.18v13.9a78.42,78.42,0,0,0,15.56-2.18,73.29,73.29,0,0,0,19.3-7.9q9.6-5.54,13.67-11.14c2.73-3.73,4-7.39,3.9-10.95C364.53,339,364.66,331,364.62,327.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.63,320.49a21.85,21.85,0,0,0,2.49,2.19c.43-.28.86-.56,1.34-.84a27,27,0,0,1,7.54-3,25.21,25.21,0,0,1,7.23-.54,28.07,28.07,0,0,1,6.91,1.39A60,60,0,0,1,304,322.5q11.11,5.85,21.47,12.41c.9.56,1.73,1.14,2.49,1.7a13,13,0,0,0,3.89-3.51,5.66,5.66,0,0,0,1-4.21,7.84,7.84,0,0,0-2.36-4,29.56,29.56,0,0,0-5.05-3.86Q315.07,314.43,304,308.6a60,60,0,0,0-6.83-2.84,28.07,28.07,0,0,0-6.91-1.39,24.87,24.87,0,0,0-7.23.55,26.61,26.61,0,0,0-7.54,3,15.46,15.46,0,0,0-5.23,4.35,5.38,5.38,0,0,0-1,4.17A8.9,8.9,0,0,0,271.63,320.49Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.63,320.49a21.85,21.85,0,0,0,2.49,2.19c.43-.28.86-.56,1.34-.84a27,27,0,0,1,7.54-3,25.21,25.21,0,0,1,7.23-.54,28.07,28.07,0,0,1,6.91,1.39A60,60,0,0,1,304,322.5q11.11,5.85,21.47,12.41c.9.56,1.73,1.14,2.49,1.7a13,13,0,0,0,3.89-3.51,5.66,5.66,0,0,0,1-4.21,7.84,7.84,0,0,0-2.36-4,29.56,29.56,0,0,0-5.05-3.86Q315.07,314.43,304,308.6a60,60,0,0,0-6.83-2.84,28.07,28.07,0,0,0-6.91-1.39,24.87,24.87,0,0,0-7.23.55,26.61,26.61,0,0,0-7.54,3,15.46,15.46,0,0,0-5.23,4.35,5.38,5.38,0,0,0-1,4.17A8.9,8.9,0,0,0,271.63,320.49Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,296.14a73,73,0,0,1,19.3-7.9,76.62,76.62,0,0,1,19-2.25,70.39,70.39,0,0,1,17.83,2.47A82.19,82.19,0,0,1,327,294.59q5.75,3,11.76,6.49t11,6.64a45.88,45.88,0,0,1,10.6,9.15,17,17,0,0,1,4.29,10.29q.19,5.35-3.9,11T347,349.26a73.29,73.29,0,0,1-19.3,7.9,76.62,76.62,0,0,1-19,2.25,69.89,69.89,0,0,1-17.83-2.48,81.52,81.52,0,0,1-15.85-6.12q-5.49-2.88-11.5-6.34t-11.25-6.79a46.12,46.12,0,0,1-10.6-9.15,17,17,0,0,1-4.29-10.3q-.18-5.34,3.9-11T255,296.14ZM325.44,321q-10.37-6.56-21.47-12.39a58.5,58.5,0,0,0-6.84-2.85,28.39,28.39,0,0,0-6.9-1.4,25.21,25.21,0,0,0-7.23.56,26.61,26.61,0,0,0-7.54,3,15.46,15.46,0,0,0-5.23,4.35,5.33,5.33,0,0,0-1,4.17,8.56,8.56,0,0,0,2.36,4,26.42,26.42,0,0,0,5,3.91,237.87,237.87,0,0,0,21.47,12.39,45.16,45.16,0,0,0,6.71,2.92,26,26,0,0,0,21.78-2.25,15.31,15.31,0,0,0,5.24-4.36,5.65,5.65,0,0,0,1-4.2,7.75,7.75,0,0,0-2.37-4A29.09,29.09,0,0,0,325.44,321Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.32,281.8l-16.74,9.66a7.65,7.65,0,0,1-6.89,0l-13-7.53-40.26,23.25a7.67,7.67,0,0,1-6.9,0l-13.55-7.82c-2.22-1.27-3.49-2.65-3.84-4.13l-10-49.88a4.82,4.82,0,0,1-.07-.89c0,1,0,13.41,0,14a5.64,5.64,0,0,0,.07.77l10,49.87c.35,1.49,1.62,2.86,3.84,4.14l13.55,7.82a7.67,7.67,0,0,0,6.9,0l40.26-23.25,13,7.53a7.65,7.65,0,0,0,6.89,0l16.74-9.66a2.34,2.34,0,0,0,1.41-2V279.8A2.35,2.35,0,0,1,461.32,281.8Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.69,275.84v-13.9a2.38,2.38,0,0,1-1.41,2l-11,6.34,11.87,6.84A1.92,1.92,0,0,0,460.69,275.84Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.46 273.89 392.79 278.72 404.84 271.77 381.32 258.18 384.45 273.89 384.46 273.89",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.46 273.89 392.79 278.72 404.84 271.77 381.32 258.18 384.45 273.89 384.46 273.89",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.69,275.84v-13.9a2.38,2.38,0,0,1-1.41,2l-11,6.34,11.87,6.84A1.92,1.92,0,0,0,460.69,275.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.32,281.8l-16.74,9.66a6.7,6.7,0,0,1-3.45.82v13.9a6.7,6.7,0,0,0,3.45-.82l16.74-9.66a2.34,2.34,0,0,0,1.41-2V279.8A2.35,2.35,0,0,1,461.32,281.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,295.23l-10-49.88a4.82,4.82,0,0,1-.07-.89c0,1,0,13.41,0,14a5.64,5.64,0,0,0,.07.77l10,49.87a3.15,3.15,0,0,0,.32.85v-13.9A3.22,3.22,0,0,1,360.1,295.23Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,308a6.83,6.83,0,0,1-3.45-.82l-13.55-7.82a8.09,8.09,0,0,1-3.52-3.29V310a8.09,8.09,0,0,0,3.52,3.29l13.55,7.82a6.83,6.83,0,0,0,3.45.82,1.63,1.63,0,0,0,.38,0V308A1.63,1.63,0,0,1,380.94,308Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,307.18a6.34,6.34,0,0,1-3.07.79v13.9a6.34,6.34,0,0,0,3.07-.79l40.26-23.25v-13.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.69,291.46l-13-7.53v13.9l13,7.53a6.64,6.64,0,0,0,3.44.82v-13.9A6.64,6.64,0,0,1,437.69,291.46Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.59,291.46a6.74,6.74,0,0,1-3.46.81,6.83,6.83,0,0,1-3.45-.81l-13-7.52-40.26,23.24a7.75,7.75,0,0,1-6.9,0l-13.55-7.82q-3.31-1.92-3.83-4.13l-10-49.88a3.29,3.29,0,0,1,.25-2.29,6.43,6.43,0,0,1,2.18-1.77l19.29-11.14a7.69,7.69,0,0,1,6.91,0l49.07,28.33,11-6.35a7.75,7.75,0,0,1,6.9,0L459.28,260a2.11,2.11,0,0,1,0,4l-11,6.35,13,7.52a2.12,2.12,0,0,1,0,4Zm-39.75-19.7-23.52-13.57,4.86,24.34Z",
    style: {
      fill: "#09B842"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.25,222.46c.87-4.06-15.7,5.51-16.57,9.57L300,246.4a2.29,2.29,0,0,0,.9,1c1.17.72,5.49,3.16,5.86,3.39a2.32,2.32,0,0,0,3.42-1.27l6.92-23.73C317.54,223.84,311.25,222.46,311.25,222.46Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,222.46c.87-4.06-15.7,5.51-16.57,9.57L300,246.4a2.29,2.29,0,0,0,.9,1c1.17.72,5.49,3.16,5.86,3.39a2.32,2.32,0,0,0,3.42-1.27l6.92-23.73C317.54,223.84,311.25,222.46,311.25,222.46Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,114.76,224.81,194.53a4.91,4.91,0,0,0-2.23,3.85v76a4.91,4.91,0,0,0,2.23,3.85l1.39.79a4.91,4.91,0,0,0,4.45,0l138.28-79.86a4.92,4.92,0,0,0,2.22-3.86V119.39a4.9,4.9,0,0,0-2.22-3.85l-1.39-.79A4.94,4.94,0,0,0,363.08,114.76Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,114.76,224.81,194.53a4.91,4.91,0,0,0-2.23,3.85v76a4.91,4.91,0,0,0,2.23,3.85l1.39.79a4.91,4.91,0,0,0,4.45,0l138.28-79.86a4.92,4.92,0,0,0,2.22-3.86V119.39a4.9,4.9,0,0,0-2.22-3.85l-1.39-.79A4.94,4.94,0,0,0,363.08,114.76Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,119.39v.87a2.06,2.06,0,0,0-3.09-1.77L231.49,197.4a5.92,5.92,0,0,0-2.24,2.23l0,.07-6-3.47a4.58,4.58,0,0,1,1.6-1.69l138.27-79.78a5,5,0,0,1,4.45,0l1.39.79A4.92,4.92,0,0,1,371.16,119.39Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,119.39v.87a2.06,2.06,0,0,0-3.09-1.77L231.49,197.4a5.92,5.92,0,0,0-2.24,2.23l0,.07-6-3.47a4.58,4.58,0,0,1,1.6-1.69l138.27-79.78a5,5,0,0,1,4.45,0l1.39.79A4.92,4.92,0,0,1,371.16,119.39Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,119a1.23,1.23,0,0,0-.62.17L231.89,198.09a5.32,5.32,0,0,0-2.66,4.6v74.08c0,.42.09,1.4.9,1.4a2,2,0,0,0,1-.32L302,236.93l4.43,12.29a2.31,2.31,0,0,0,4.31-.22l6-20.58,51-29.44c1.85-1.06,2.67-2.14,2.67-3.49V120.26A1.25,1.25,0,0,0,369.1,119Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.13,279c-1,0-1.69-.86-1.69-2.19V202.69a6.14,6.14,0,0,1,3.05-5.29l136.59-78.9a2,2,0,0,1,1-.28,2.05,2.05,0,0,1,2,2v75.23c0,2.16-1.76,3.42-3.07,4.18L317.4,229l-5.91,20.27a3.1,3.1,0,0,1-5.81.32l-4.13-11.44L231.5,278.54A2.74,2.74,0,0,1,230.13,279Zm139-159.15a.49.49,0,0,0-.23.06l-136.58,78.9a4.54,4.54,0,0,0-2.27,3.92v74.08a1.1,1.1,0,0,0,.13.62,2,2,0,0,0,.56-.22l71.69-41.4L307.16,249a1.48,1.48,0,0,0,1.44.86,1.51,1.51,0,0,0,1.37-1.05l6.08-20.87.27-.16,51-29.44c2-1.15,2.28-2.06,2.28-2.8V120.26A.46.46,0,0,0,369.1,119.81Z",
    style: {
      fill: "#09B842"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,222a35.25,35.25,0,0,1,1-7.15,32.53,32.53,0,0,1,2.47-6.79,28.7,28.7,0,0,1,3.89-5.86,20.57,20.57,0,0,1,5.28-4.39,10.77,10.77,0,0,1,5.27-1.69,5.79,5.79,0,0,1,3.9,1.36,8.56,8.56,0,0,1,2.47,3.93,21.13,21.13,0,0,1,1,6c.06,1.76.09,3.61.09,5.57s0,3.79-.09,5.53a35.45,35.45,0,0,1-1,7.15,32.35,32.35,0,0,1-2.47,6.81,27.19,27.19,0,0,1-3.9,5.88,20.59,20.59,0,0,1-5.27,4.34,10.85,10.85,0,0,1-5.28,1.74,5.7,5.7,0,0,1-3.89-1.37,8.86,8.86,0,0,1-2.47-4,21.26,21.26,0,0,1-1-6c-.05-1.67-.08-3.48-.08-5.43S244.64,223.8,244.69,222Zm17.77.52c0-.76.06-1.61.09-2.54s0-1.87,0-2.83,0-1.87,0-2.75-.06-1.66-.09-2.35a10.64,10.64,0,0,0-.42-2.62,4,4,0,0,0-1-1.72,2.29,2.29,0,0,0-1.56-.63,4.35,4.35,0,0,0-2.19.71,8.29,8.29,0,0,0-2.18,1.82,11,11,0,0,0-1.56,2.43,13.68,13.68,0,0,0-1,2.83,18.75,18.75,0,0,0-.43,3.12c-.05.73-.09,1.55-.1,2.45s0,1.83,0,2.79,0,1.89,0,2.79,0,1.72.1,2.44a6.93,6.93,0,0,0,1.4,4.36q1.23,1.35,3.74-.1a8.82,8.82,0,0,0,3.73-4.21A17.3,17.3,0,0,0,262.46,222.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34,201.53c0,.6,0,1.4,0,2.37s0,1.79,0,2.43a27.25,27.25,0,0,1-.89,6.12,29,29,0,0,1-2.23,5.87,24.18,24.18,0,0,1-3.42,5.06,17.92,17.92,0,0,1-4.47,3.7,9.46,9.46,0,0,1-4.48,1.46,5.07,5.07,0,0,1-3.42-1.11,7.45,7.45,0,0,1-2.22-3.29,15.92,15.92,0,0,1-.9-5.1c0-.61,0-1.4,0-2.38s0-1.78,0-2.42a26,26,0,0,1,.85-6.1,28.8,28.8,0,0,1,2.25-5.88,26.06,26.06,0,0,1,3.44-5.1,17.54,17.54,0,0,1,4.48-3.74A9.21,9.21,0,0,1,288.8,192a5.41,5.41,0,0,1,3.44,1.13,7.29,7.29,0,0,1,2.23,3.3A16.55,16.55,0,0,1,295.34,201.53Zm-14.74,13c.08,1.54.45,2.56,1.11,3.07s1.54.45,2.62-.17a6.72,6.72,0,0,0,2.61-2.85,10.43,10.43,0,0,0,1.11-4.35c.05-.65.08-1.37.08-2.16s0-1.48-.08-2.08q-.12-2.29-1.11-3.06c-.66-.51-1.53-.46-2.61.17a6.84,6.84,0,0,0-2.62,2.84,10.52,10.52,0,0,0-1.11,4.36c-.05.65-.08,1.37-.08,2.16S280.55,213.93,280.6,214.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.86,211.19a6.36,6.36,0,0,1-2.07.82,3.71,3.71,0,0,1-1.54,0,2.8,2.8,0,0,1-1.09-.59,4.41,4.41,0,0,1-.73-.79v13.28a3.3,3.3,0,0,1-.32,1.37,2,2,0,0,1-.77.94l-5.1,3a.59.59,0,0,1-.77-.06,1.32,1.32,0,0,1-.33-1V187.17a3.17,3.17,0,0,1,.33-1.37,2,2,0,0,1,.77-.94l4.9-2.83a.59.59,0,0,1,.77.06,1.35,1.35,0,0,1,.32,1v1.44c.24-.56.51-1.15.79-1.77a10.82,10.82,0,0,1,1.05-1.82,12.2,12.2,0,0,1,1.54-1.76,11.68,11.68,0,0,1,2.25-1.64,8,8,0,0,1,3.44-1.15,3.78,3.78,0,0,1,2.83,1,7.56,7.56,0,0,1,2,3.32,20.7,20.7,0,0,1,.83,5.88c0,.6,0,1.44,0,2.5s0,1.91,0,2.55a32.49,32.49,0,0,1-.83,6.83,27.53,27.53,0,0,1-2,5.59,18.68,18.68,0,0,1-2.83,4.29A14.34,14.34,0,0,1,311.86,211.19Zm1.82-16.14a25.4,25.4,0,0,0,0-3.49,6.25,6.25,0,0,0-.93-3.26c-.54-.77-1.45-.79-2.72-.06a5.56,5.56,0,0,0-1.53,1.33,8.38,8.38,0,0,0-1.08,1.77,11.69,11.69,0,0,0-.66,2,12.08,12.08,0,0,0-.33,2c-.05.65-.08,1.4-.08,2.23s0,1.54.08,2.13a6.64,6.64,0,0,0,.33,1.62,3.42,3.42,0,0,0,.66,1.21,1.64,1.64,0,0,0,1.08.53,2.68,2.68,0,0,0,1.53-.45,6.14,6.14,0,0,0,2.72-3.19A14,14,0,0,0,313.68,195.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,186.49c0-.46-.1-.75-.3-.89a1.38,1.38,0,0,0-1,0,17.18,17.18,0,0,0-1.93.61c-.79.29-1.78.62-3,1q-3.08.9-4.74-.76c-1.11-1.1-1.66-3.07-1.66-5.89a14.43,14.43,0,0,1,.69-4.33,20.45,20.45,0,0,1,1.92-4.29,20.81,20.81,0,0,1,3-3.87,18.12,18.12,0,0,1,3.89-3,10.76,10.76,0,0,1,3.88-1.46,6.28,6.28,0,0,1,3.08.22,4,4,0,0,1,2,1.62,5.29,5.29,0,0,1,.83,2.67,2.65,2.65,0,0,1-.3,1.36,2.15,2.15,0,0,1-.79,1l-4.82,2.78c-.3.17-.53.21-.71.1a5,5,0,0,0-.62-.32,2.07,2.07,0,0,0-.95-.14,4,4,0,0,0-1.64.64,5.52,5.52,0,0,0-1.56,1.3,2.62,2.62,0,0,0-.63,1.7,1.67,1.67,0,0,0,.2,1q.21.25.81.12a16.76,16.76,0,0,0,1.7-.51c.73-.26,1.69-.58,2.88-1,2.45-.79,4.24-.55,5.36.74a8.38,8.38,0,0,1,1.68,5.67,14.71,14.71,0,0,1-.69,4.35,19.31,19.31,0,0,1-2,4.41,22.57,22.57,0,0,1-3.24,4.09,20.94,20.94,0,0,1-4.33,3.31,11.81,11.81,0,0,1-4.27,1.62,5.66,5.66,0,0,1-3.1-.36,4.16,4.16,0,0,1-1.92-1.76,5.75,5.75,0,0,1-.75-2.62,2.63,2.63,0,0,1,.3-1.36,2.15,2.15,0,0,1,.79-1l5-2.9c.3-.17.51-.18.65,0a2.61,2.61,0,0,0,.52.44,1.57,1.57,0,0,0,.93.21,4.25,4.25,0,0,0,1.83-.71,8.37,8.37,0,0,0,2.1-1.71A3,3,0,0,0,336.71,186.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,170.59a3.3,3.3,0,0,1-.32,1.37,2,2,0,0,1-.77.94l-5.1,2.95a.59.59,0,0,1-.77-.06,1.31,1.31,0,0,1-.32-1V147.93a3.12,3.12,0,0,1,.32-1.37,2,2,0,0,1,.77-.94l5.1-3a.59.59,0,0,1,.77.06,1.34,1.34,0,0,1,.32,1Zm0,13.4a3.26,3.26,0,0,1-.32,1.37,2,2,0,0,1-.77.94l-5.1,2.95a.59.59,0,0,1-.77-.06,1.3,1.3,0,0,1-.32-1v-6.3a3.12,3.12,0,0,1,.32-1.37,2,2,0,0,1,.77-.94l5.1-3a.59.59,0,0,1,.77.06,1.35,1.35,0,0,1,.32,1Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.62,216.28a18.55,18.55,0,0,1,1.64,4.58c.74,3.94-.68,7.91-1.47,11.83-.26,1.33-.35,2.55.6,3.59a.86.86,0,0,0,.74.35c.24-.06.4-.3.53-.51A24,24,0,0,0,162.9,231a26,26,0,0,1-.17,5.07,9.25,9.25,0,0,0,0,4c.42,1.28,1.86,2.31,3,1.68a3.5,3.5,0,0,0,1.33-2.18l.93-3a39.12,39.12,0,0,0,1.13-4.25,20,20,0,0,0-3.23-15,7.21,7.21,0,0,0-3-2.69,4.29,4.29,0,0,0-3.62.21C158.5,215.26,158.25,215.53,158.62,216.28Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,223.16c-.43-5.25-.61-10.75-1.59-15.72s-3.06-24.08-4-29.39c-1.23-7-2.9-11.38-3.92-15.71-1.15-4.84-2.11-11.46-4.14-22s-4.52-16.44-9.73-19.84a23.19,23.19,0,0,0-13-4c-1.18,3.24-.09,14.58-.09,14.58s5,24.18,5.54,27.15,5.89,16.56,9.47,27.62c2.05,6.35,5.15,15.28,5.15,15.28.94,3.95,1.27,5.21.48,8.34-.33,1.32-.86,2.58-1.19,3.9a23.28,23.28,0,0,0-.66,4.39c-.05,1,0,2-.09,3-.09,1.85-.39,3.69-.61,5.53-.15,1.35.63,2.18,2,1.76a4.13,4.13,0,0,0,2.25-2.08,17.37,17.37,0,0,0,1.19-4.23c.16-.69,1-4.84,2.31-3.71,1.12.95,2.31,4.19,3.78,6.39a9.13,9.13,0,0,1,2,7c-.25,3.35-1.85,7.83-1.31,10.66s2.12,3.44,2.69,2.27,2.3-8,2.88-10.37A33.22,33.22,0,0,0,171.42,223.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,219.44c6.09,2.68,13.68,4.14,17,17.14s7.25,60.77,7.25,60.77a16.54,16.54,0,0,1-13.29,6.26l.54,13.63s-8.9,4.28-22.16.93c-6.43-1.62-10.39-7.5-10.39-7.5s1.51-38.57,2.56-53.3S142.35,212.25,158.45,219.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.26,251.15s1.62,39,2.15,52.46a18,18,0,0,0,4.39-.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.63,220.73c-.09,1.85-.39,3.69-.61,5.53-.15,1.35.63,2.18,2,1.76a4.13,4.13,0,0,0,2.25-2.08,17.37,17.37,0,0,0,1.19-4.23c.12-.53.63-3.08,1.46-3.74l-6.19-.23C153.67,218.73,153.68,219.73,153.63,220.73Zm6.28-2.76.85,0A.59.59,0,0,0,159.91,218Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.64,115.79c9.87,4.06,13,7.33,14.91,13.31s4.92,21.1,5.91,27.67,3.47,12.48,4.85,21.07S169.05,199,169.05,199s-1.79,2.3-7.19,2.62-8.21-1.63-8.21-1.63-5.74-17.15-7.91-22.88-7.14-20-7.14-20Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-95"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 354.45 62.79 356.47 63.78 351.72 58.38 352.23 56.2 354.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58,341.17s-2.76,3.17-3.61,4.18,1.11,7.71,1.8,9.1l2.18-2.22c.22,1.69-.14,3.35-.49,5.94-.29,2.15-1.37,5.82-.49,9.57,1.31,5.57,5.66,11.23,11.09,15.73s9.67,5.58,12.19,5.6,4.11-1,4.8-2.74S58,341.17,58,341.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.68,341.31l1.56-1.88c1.05.76-1,3.65-1.37,7.26A62.79,62.79,0,0,0,82,362.78c1.69,9.51,4.24,16.64,5,20.9,1,5.71-8.75,6.08-17.46-1.44-4.33-3.74-10.61-12.19-10.81-16.6s1.62-9.64,1.3-13-2.68-8.28-2-11.5c.38-1.77,3-4.54,5.38-6.83,2.15-2.09,4-6.62,5.07-5.31l-.8,1.56c-.25,1.45.7,4.82,3.87,8.24C73.11,340.54,78.42,344.88,81.68,341.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38,341.18c1.86,1.19,4.17,2.05,6.11,1.05,0,0,.05,0,.07,0a5.59,5.59,0,0,0-1.68,4.62c.16,3.16.1,24.52.1,24.52s-1-18.46-1.27-22c-.34-5.18-.92-6.2-3.34-8.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,383.68c-.62-3.6-2.54-9.25-4.14-16.65-.22,2.29.27,4.57,0,5.19-.61,1.54-5.71.41-8.46-.74s-2.81-6.41-3.9-12-6.71-4.38-11-1.11a34.46,34.46,0,0,0-.75,7.22c.2,4.41,6.48,12.86,10.81,16.6C78.23,389.76,88,389.39,87,383.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,346.49a.7.7,0,1,1,0-1A.7.7,0,0,1,73.91,346.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.31,351.53a.7.7,0,1,1,0-1A.7.7,0,0,1,74.31,351.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,356.57a.7.7,0,0,1-1-1,.71.71,0,0,1,1,0A.7.7,0,0,1,74.71,356.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,361.61a.71.71,0,0,1-1,0,.7.7,0,0,1,0-1,.7.7,0,0,1,1,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.52,366.66a.71.71,0,0,1-1,0,.7.7,0,0,1,0-1,.71.71,0,0,1,1,1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.22,346.21a.22.22,0,0,1-.09-.17.28.28,0,0,1,.24-.32c.2,0,4.87-.54,8.22,2.36h0a.28.28,0,1,1-.37.43c-3.16-2.74-7.73-2.23-7.78-2.23A.22.22,0,0,1,73.22,346.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.63,351.25a.26.26,0,0,1-.09-.18.27.27,0,0,1,.24-.31c.2,0,4.87-.55,8.22,2.35h0a.28.28,0,1,1-.37.43c-3.16-2.74-7.73-2.23-7.78-2.22A.28.28,0,0,1,73.63,351.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,356.3a.31.31,0,0,1-.09-.18.27.27,0,0,1,.24-.31c.2,0,4.87-.55,8.22,2.35h0a.28.28,0,1,1-.37.43c-3.16-2.74-7.73-2.23-7.78-2.22A.29.29,0,0,1,74,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.42,361.34a.31.31,0,0,1-.09-.18.28.28,0,0,1,.24-.31c.2,0,4.87-.55,8.22,2.35h0a.29.29,0,0,1,0,.4.28.28,0,0,1-.4,0c-3.16-2.74-7.73-2.23-7.78-2.22A.29.29,0,0,1,74.42,361.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.82,366.38a.31.31,0,0,1-.09-.18.27.27,0,0,1,.25-.31c.19,0,4.86-.55,8.21,2.35h0a.28.28,0,0,1,0,.39.28.28,0,0,1-.4,0c-3.15-2.73-7.73-2.23-7.78-2.22A.29.29,0,0,1,74.82,366.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76,195.49s.72,12.49.1,38.46c-.52,21.73,1.88,33-6.84,46.84-7.79,12.35-56.41,59.53-59.92,63.81,0,0-15.39,1.4-16.14-14.37,0,0,14.33-25.59,21.09-40.1s16-21.47,16-21.47L90.42,205.4Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.79,204.49l-5.34.9,0,.23,12.17,61,.41,1.53h0l-.1,0,.1.47s-6.57,5-12.69,15.24C92.5,289.38,96.74,299,96.74,299c.38,1.49-3.92,7.59-1.47,25.95.18,1.32.5,3.24.87,5.31C107.08,319.2,122,304.15,132,293c.49-2.87,2-12.32,1.12-19.54S129,230.82,129,230.82a29.88,29.88,0,0,0,8.08-7.43,19.71,19.71,0,0,0,3.77-8.18A122.07,122.07,0,0,0,145,200.72Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.98 406.31 121.53 404.16 119.61 399.71 115.48 403.23 114.98 406.31"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,394.39s-.44,4.19-.55,5.51,5.34,5.67,6.71,6.41l.5-3.08c1.16,1.26,1.81,2.82,3,5.14,1,1.93,2.23,5.56,5.11,8.11,4.27,3.8,11.09,5.93,18.11,6.49s11.13-1,13.2-2.44,2.77-3.2,2.35-5S108.82,394.39,108.82,394.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,380.89l.19-2.43c1.3,0,1.3,3.55,3.06,6.72,2.37,4.27,5.88,9.64,9.36,13.09,6.85,6.81,13,11.17,16.1,14.23,4.1,4.1-3.66,10-15.11,8.87-5.69-.57-15.69-3.87-18.39-7.36s-4.23-8.82-6.4-11.36-7-5.22-8.25-8.26c-.71-1.66-.13-5.45.47-8.67.56-3-.57-7.7,1.09-7.26l.25,1.73c.63,1.33,3.33,3.54,7.9,4.52C120.81,385.19,127.64,385.69,128.26,380.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,385c2.2-.1,4.6-.72,5.6-2.66l0-.06a5.56,5.56,0,0,0,1.28,4.74c2,2.49,14.2,20,14.2,20s-11.47-14.49-13.68-17.22c-3.25-4-4.32-4.54-7.45-4.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,412.5c-2.58-2.59-7.4-6.1-13-11.23,1.15,2,2.86,3.58,3,4.23.38,1.61-4.44,3.62-7.35,4.26s-6-3.62-10.07-7.53-8,.28-9.66,5.44a34.48,34.48,0,0,0,3.54,6.34c2.7,3.49,12.7,6.79,18.39,7.36C153.31,422.5,161.07,416.6,157,412.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89,389.6a.7.7,0,1,1-1.39-.21.69.69,0,0,1,.8-.59A.71.71,0,0,1,124.89,389.6Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.11,393.49a.69.69,0,0,1-.8.59.7.7,0,1,1,.8-.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,397.39a.7.7,0,0,1-1.39-.22.72.72,0,0,1,.81-.59A.7.7,0,0,1,131.34,397.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.57,401.28a.7.7,0,1,1-1.39-.22.7.7,0,0,1,1.39.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,405.17a.7.7,0,1,1-.59-.8A.7.7,0,0,1,137.8,405.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.16,389.78a.27.27,0,0,1-.18-.1.29.29,0,0,1,0-.4c.15-.13,3.67-3.24,8.08-2.8h0a.28.28,0,0,1,.25.31.29.29,0,0,1-.31.26c-4.16-.42-7.61,2.62-7.64,2.65A.32.32,0,0,1,124.16,389.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,393.65a.23.23,0,0,1-.18-.09.29.29,0,0,1,0-.4c.15-.13,3.67-3.24,8.08-2.8h0a.28.28,0,0,1,.25.31.29.29,0,0,1-.31.26c-4.15-.42-7.61,2.62-7.64,2.65A.26.26,0,0,1,127.39,393.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.61,397.56a.28.28,0,0,1-.17-.09.27.27,0,0,1,0-.4c.15-.13,3.66-3.25,8.07-2.8h0a.28.28,0,0,1-.06.56c-4.16-.42-7.61,2.63-7.64,2.66A.29.29,0,0,1,130.61,397.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,401.45a.28.28,0,0,1-.17-.09.28.28,0,0,1,0-.4c.14-.13,3.66-3.25,8.07-2.8h0a.28.28,0,0,1,.24.31.27.27,0,0,1-.31.25c-4.15-.42-7.6,2.63-7.64,2.66A.26.26,0,0,1,133.84,401.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.07,405.34a.23.23,0,0,1-.18-.09.29.29,0,0,1,0-.4c.14-.13,3.66-3.24,8.07-2.8h0a.28.28,0,0,1,.24.31.28.28,0,0,1-.31.26c-4.15-.42-7.6,2.62-7.64,2.65A.26.26,0,0,1,137.07,405.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.75,191.46s-.35,16-.28,23.18c.14,14.74,3,20.81,6.64,33.21,3,10.06,15.07,47,16,50.57-1.28,7.8-2.63,14.7,0,31.73,3.77,24.58,8,53.77,8,53.77,2.25,3.12,17.59,4.25,22.05-.27,0,0,1.32-78.64.84-94.71-.41-14-6.93-59.77-6.93-59.77s20.9-8.79,22.7-33.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.8,108.26s22.9,1.55,35.84,7.53c2.89,1.33,11.49,12.6,10.47,28.13-2.58,39.12-1.55,60.88-1.55,60.88-.71,2-8.13,12.8-28.61,14.74-21.1,2-33-.18-42.92-8.89.07-16.61.36-37.82.54-52.07.14-11,.31-18,1.59-25.78.85-5.17,3-12.9,6.55-14.89a101.4,101.4,0,0,1,12.42-6A16.39,16.39,0,0,0,104.8,108.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,109.29c3.23.25,23.4,2,35,7.4,2.64,1.22,10.88,12.07,9.88,27.16-2.41,36.65-1.65,58.36-1.55,60.78-.41.89-2.25,3.75-6.47,6.74-3.83,2.72-10.62,6.17-21.23,7.18-4.86.46-9.06.69-12.84.69-12.92,0-21.63-2.71-29-9,.06-14.71.3-33.17.47-46.68l.06-4.93c.14-10.82.32-18,1.58-25.63,1-5.9,3.23-12.58,6.06-14.18a100,100,0,0,1,12.31-6,17.73,17.73,0,0,0,5.67-3.54m-.38-1a16.39,16.39,0,0,1-5.67,3.65,101.4,101.4,0,0,0-12.42,6c-3.51,2-5.7,9.72-6.55,14.89-1.28,7.75-1.45,14.83-1.59,25.78-.18,14.25-.47,35.46-.54,52.07,7.67,6.75,16.56,9.58,30,9.58,3.9,0,8.18-.24,12.93-.69,20.48-1.94,27.9-12.75,28.61-14.74,0,0-1-21.76,1.55-60.88,1-15.53-7.58-26.8-10.47-28.13-12.94-6-35.84-7.53-35.84-7.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.25,64.22c-6.21,7-4.2,15.26-2,23.54,2.6,9.43,2.76,12.48,8.18,14.84-1.22-29.61,8.24,6.67,32-16.35,4.29-4.16,4.56-17-.64-22.88C135.44,55.11,117.39,51,105.25,64.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,97.06c4.32,1.8,6.28-1.17,6.28-1.17l-3.82,11S104,113.71,109.56,117c15.38,9.24,11.9,13.13,17.1,17.62,1.76-2.21,1.53-12.11,1.81-14.72l3.37-10.59a32.76,32.76,0,0,0,5.26-.24c4.12-.58,6.45-3.51,7.75-7.93,2.07-7.12,1.76-17.86-.79-31.77C139.51,65.78,124.43,65,114.68,71c.35,8.18-1.87,9.51-1.87,13,0,3.95-.27,4.86-1.48,5.39s-2.29-1.32-2.78-2.48c-.82-2-1.52-3.22-3.45-3.7s-4.09-.17-5.86,2.43C96.5,89.68,100.82,95.76,104,97.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84,109.35c-4.87-.24-11.71-2.8-14.47-5.38s-4.56-7.6-4.56-7.6a15.72,15.72,0,0,0,3.52,9.34c3.6,4.38,14.49,6.85,14.49,6.85Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.25,73.31c-.13,0-.29.08-.3.21s.13.17.23.23a4,4,0,0,1,.48.32,1.3,1.3,0,0,1,.39.42,1.85,1.85,0,0,1,.12.4,5.19,5.19,0,0,1,.05.68c0,.19.16.32.34.16a.57.57,0,0,0,.15-.22,1.71,1.71,0,0,0,.13-.8,1.69,1.69,0,0,0-.12-.44A1.62,1.62,0,0,0,129.25,73.31Zm7.44.3a.43.43,0,0,0-.54-.51,1.87,1.87,0,0,0-1,1.23,2,2,0,0,0,.4,2.15c.09.08.22.15.31.09s0-1,.07-1.21a2.11,2.11,0,0,1,.29-1C136.34,74.13,136.61,73.91,136.69,73.61Zm-4.05-1.75a.13.13,0,0,0-.2.07.64.64,0,0,0,.11.53,4.24,4.24,0,0,1,.23.59A4.49,4.49,0,0,1,133,74.3a6.74,6.74,0,0,1-.08,1.19c-.06.37-.17.73-.23,1.1,0,0,0,.14.08.1a2.79,2.79,0,0,0,.8-2.25,4.82,4.82,0,0,0-.21-1.36A2.3,2.3,0,0,0,132.64,71.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.87,76.75l4.4-1.69a2.47,2.47,0,0,1-1.4,3.12A2.3,2.3,0,0,1,123.87,76.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,74.39l4.26,2.1A2.28,2.28,0,0,1,139,77.63,2.49,2.49,0,0,1,137.85,74.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.27,81.29c-.41-1-1,.41-2.2.91s-2.51-.12-2.1.87a2.37,2.37,0,0,0,4.3-1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.14,82.27c.25-1-1-.25-2.31-.54s-2-1.56-2.22-.52a2.36,2.36,0,0,0,4.53,1.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,78.9l1.78,13,6.48-1.5C138.51,86.63,134.49,80.62,131.68,78.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,94.93a2.28,2.28,0,0,0-.74.74c-.57.94.24,1.42,1.1,1.5a7.66,7.66,0,0,1,2.72.78,2.11,2.11,0,0,0,1.25.4,1.09,1.09,0,0,0,.72-.43,1.31,1.31,0,0,0,.14-.8,3.25,3.25,0,0,0-2-2.52A3.63,3.63,0,0,0,128.71,94.93Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.79,98a6,6,0,0,0,.62.31,4.08,4.08,0,0,0-3.94-3.14,2,2,0,0,0-.5.55c-.57.94.24,1.42,1.1,1.5A7.66,7.66,0,0,1,131.79,98Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.86,141.09c-4.69-3.26-13.47-10.45-20.75-31.79l-2.88,2s4.62,21.93,22.93,33.07Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,140.67c1.35-1.84,4.46-14.37,1.35-27.83l2.55,2.45c2.62,13.15-.22,25.39-2.67,29.06Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.13,147.47s5.51,38.72,5.73,42.52-5.75,13-6.56,13.51S122.14,195,122.07,192s3.87-44.54,3.87-44.54Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,140.67a8.31,8.31,0,0,0-4.48.42c-.84,1.51-1.14,3.85-.48,4.95s1.9,2.8,3.42,2.73,2.8-2,3-3.85C131,142.92,129.34,140.67,129.34,140.67Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,140.67a8.31,8.31,0,0,0-4.48.42c-.84,1.51-1.14,3.85-.48,4.95s1.9,2.8,3.42,2.73,2.8-2,3-3.85C131,142.92,129.34,140.67,129.34,140.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59,134.66c-2.69-3.07-3.63-12.3-5.62-13.85s-13.54-8.61-14.63-13.68l1.28-3.69c-1.38-.63-3.24,3.78-8.49,8.47,0,0-.65,5.36,3.37,11.45,4.73,7.19,8.88,9.6,8.88,9.6s5.78-7.46,6.73-7.75S123.37,133.56,126.59,134.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.59,134.66c1.44-2.52,1.21-12.88,1.62-14.25.86-2.88,3.39-10.33,3.39-10.33a6.59,6.59,0,0,1,1.14,1.12c4.78,6.18,4.63,15.1,3.32,17.85-1.38-2.93-4.66-6.71-5.25-6S129.06,133.43,126.59,134.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Briefcase--inject-95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.73,261.2l2.34,47.64c.11,2.31-1.45,3.72-3.39,5L102.81,317a4.84,4.84,0,0,1-3.88,1,10.66,10.66,0,0,1-2.73-1,.18.18,0,0,1-.1,0l-.28-.15-52.66-27a12.08,12.08,0,0,1-6.56-10.17l-2.13-43.38a3.44,3.44,0,0,1,1.43-2.77l8.3-5.35a3.4,3.4,0,0,1,3.1-.15L107,258.59a3.2,3.2,0,0,1,1.16,1.1A3.24,3.24,0,0,1,108.73,261.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.73,261.2l2.34,47.64c.11,2.31-1.45,3.72-3.39,5L102.81,317a4.84,4.84,0,0,1-3.88,1,10.66,10.66,0,0,1-2.73-1v0c2,.84,3.57-.28,3.45-2.64l-2.2-44.88a4.81,4.81,0,0,0-.81-2.29l11.56-7.45A3.24,3.24,0,0,1,108.73,261.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.45,269.43a5.23,5.23,0,0,0-2.55-4l-56.46-29c-2.23-1.15-4,0-3.83,2.47l2,40.61a12.1,12.1,0,0,0,6.56,10.18l52.66,27c2.23,1.15,4,0,3.83-2.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.51,229.79l59.86,31.07a5.48,5.48,0,0,1,2.93,4.57l2.41,49-.86.56-2.44-49.55a4.59,4.59,0,0,0-2.45-3.82l-60.31-31.3Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.44,262.76a5.44,5.44,0,0,1,.86,2.67l2.41,49-.86.56-2.44-49.55a4.5,4.5,0,0,0-.72-2.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.69,263.24a4.5,4.5,0,0,0-1.73-1.59l-60.31-31.3.86-.56,59.86,31.07a5.57,5.57,0,0,1,2.07,1.9",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.48,234.87l.36,7.37L60,244.05l-.48-9.8c0-.5.31-.72.76-.49Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.48,234.87l.36,7.37L60,244.05l-.48-9.8c0-.5.31-.72.76-.49Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.11,241.16l.59,11.94L81,254.83l-1.9-1-.49-9.8a1.76,1.76,0,0,0-.85-1.33L63.33,235.3l-3-1.54c-.45-.23-.79,0-.76.49l.48,9.8-1.91-1-.59-11.94a.86.86,0,0,1,0-.16,1.74,1.74,0,0,1,.72-1.25l1.14-.74A1.79,1.79,0,0,1,61,228.9l21.26,10.93A1.72,1.72,0,0,1,83.11,241.16Z",
    style: {
      fill: "#09B842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44,242.89,81,254.83l-1.9-1-.49-9.8a1.76,1.76,0,0,0-.85-1.33L63.33,235.3l-3-1.54c-.45-.23-.79,0-.76.49l.48,9.8-1.91-1-.59-11.94a.86.86,0,0,1,0-.16c.05-.39.36-.54.76-.34l21.27,10.93A1.77,1.77,0,0,1,80.44,242.89Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,233.74l9.06,4.66a7.93,7.93,0,0,0-1.2-4c-1-1-5-5-6.34-4.59C71.31,230,70.72,231.74,70.42,233.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,239a4.9,4.9,0,0,0,.28.82,14.06,14.06,0,0,0,3.86,4.51,6.08,6.08,0,0,0,2.9-1.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,122.25c-6.58,2.89-11.35,7.94-14.75,18.67s-7.56,23.47-9.22,34.64-3.11,34.5-3.52,41.73a64.28,64.28,0,0,0-.23,8.77,70.83,70.83,0,0,0,1.59,9.83,4.61,4.61,0,0,0,2.69,3.51,6,6,0,0,1,1.16.44c.67.41,1,1.23,1.53,1.79a3.65,3.65,0,0,0,2.48.93c.41,0,.82,0,1.22.05,1.49.22,2.58,1.54,4,2a4.39,4.39,0,0,0,3.3.08,10.12,10.12,0,0,0,1.56-1c.27-.2,1-.93,1.23-1.14-2,.18-3.47-1.48-4.23-3a14.88,14.88,0,0,1-1.42-5.82,3.31,3.31,0,0,1,.2-1.4.64.64,0,0,1,.51-.42c.26,0,.43.25.57.47a14.08,14.08,0,0,0,3.2,4.18,3.14,3.14,0,0,0,2,.83,1.44,1.44,0,0,0,1.45-1.33,2.29,2.29,0,0,0-.26-.83A38.69,38.69,0,0,1,77,228.66a25.07,25.07,0,0,0-2.17-6.1c-1.11-2-3.71-4.72-3.43-7,.46-3.91,7.69-34.42,7.69-34.42s8.72-26.7,10.81-33.76C92.52,138.61,90.69,127.35,84.37,122.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71,117.91c-10.52,5.36-13.07,9.59-15.95,17.56-2.59,7.13-8.34,26.68-9.78,33.64-2.56,12.45-4,36.26-4,36.26s1.24,3.42,7.47,4.92,8.72-.41,8.72-.41l7-30.24S91,154.54,91.88,151C93.71,143.89,95.22,122.7,86.71,117.91Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.79,97.93c.26.67.39,1.38.69,2a7,7,0,0,0,1.15,1.73,5.81,5.81,0,0,0,3.74,1.89c3.07.27,6.48-2.29,5.78-5.62a.55.55,0,0,1,.54-.62c2-.2,3.11-2.22,3.09-4.1a4.07,4.07,0,0,0-3.34-4.3,6.21,6.21,0,0,0-1.29-.07,8.79,8.79,0,0,1-1.25.11c-.8-.07-.88-1.08-1.22-1.64a4.31,4.31,0,0,0-7.17-.49,6.12,6.12,0,0,0-1.06,3c0,.12-.31.47-.38.2a4.75,4.75,0,0,1,2.42-5.08,5.35,5.35,0,0,1,6.08.58,5.11,5.11,0,0,1,1,1.1,4.28,4.28,0,0,1,.38.7c.06.12.18.68.28.74a2.38,2.38,0,0,0,.58-.06c.25,0,.51,0,.76,0a7,7,0,0,1,1.71.2,4.88,4.88,0,0,1,3.61,4.89,5,5,0,0,1-3.59,5.08c.42,3.68-3.23,6.46-6.71,6.37a6.71,6.71,0,0,1-4.59-2c-1.06-1.06-2.24-2.86-1.95-4.42C166.08,97.77,166.65,97.56,166.79,97.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27,93a24.34,24.34,0,0,1,4.89-1l2.14-.34a13.28,13.28,0,0,1,2.27-.27c.35,0,.15.48-.06.56a14,14,0,0,1-2.4.57l-2.27.4-2.17.35a9.53,9.53,0,0,1-2.44.18C154,93.46,154.12,93.07,154.27,93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.56,97.58a3.82,3.82,0,0,1,.88-.18c.34-.05.67-.08,1-.11l1.75-.1c.59,0,1.17,0,1.76-.06a8.58,8.58,0,0,1,2.09.05c.33.07,0,.54-.17.59a11.25,11.25,0,0,1-1.74.15l-1.82.1-1.8.11-.84.05a4.45,4.45,0,0,1-1.21,0C155.19,98.06,155.39,97.65,155.56,97.58Z",
    style: {
      fill: "#455a64"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error1);
export default __webpack_public_path__ + "static/media/404error1.c8c918a9801a0dd0b3698f2479481c7b.svg";
export { ForwardRef as ReactComponent };